import classes from './ChooseDate.module.scss'
import { DayPicker } from 'react-day-picker'
import { useState } from 'react'
import type { DayPickerStyle } from './types'
import type {
  Modifiers,
  PropsBase
} from 'react-day-picker'

export interface Props {
  isPastAllowed?: boolean
  onChange: (value: string) => void
  value: string
}

const weekdaysShort = [
  'S',
  'M',
  'T',
  'W',
  'T',
  'F',
  'S'
]

const weekdayFormatter = (day: Date) => weekdaysShort[day.getDay()]

const labels: PropsBase['labels'] = {
  labelNext: () => 'Next Month',
  labelPrevious: () => 'Previous Month'
}

const today = new Date()

const convertedClassNames: DayPickerStyle = {
  root: classes.ChooseDate,
  caption_label: classes.Header,
  month_grid: classes.MonthGridWrapper,
  weekdays: classes.Weekdays,
  weekday: classes.Weekday,
  weeks: classes.Weeks,
  week: classes.Week,
  day: classes.Day,
  button_previous: classes.PreviousButton,
  button_next: classes.NextButton
}

const getDisabledDays = (isPastAllowed: boolean) =>
  isPastAllowed
    ? { after: today }
    : { before: today }

const ChooseDate = ({
  isPastAllowed = false,
  onChange,
  value
}: Props) => {
  const [selectedDate, setSelectedDate] = useState(new Date(value))
  const [displayingMonth, setDisplayingMonth] = useState(selectedDate)

  const handleChange = (date: Date, modifiers: Modifiers) => {
    if (modifiers.disabled) return

    const newDate = new Date(value) // copy the date to prevent mutation with unknown side effects, for example time section migth reset to 12

    date.setHours(newDate.getHours())
    date.setMinutes(newDate.getMinutes())

    setDisplayingMonth(date)
    onChange(date.toISOString())
    setSelectedDate(date)
  }

  return (
    <DayPicker
      classNames={convertedClassNames}
      defaultMonth={selectedDate}
      disabled={getDisabledDays(isPastAllowed)}
      formatters={
        {
          formatWeekdayName: weekdayFormatter
        }
      }
      labels={labels}
      mode='single'
      month={displayingMonth}
      onDayClick={handleChange}
      onMonthChange={setDisplayingMonth}
      selected={selectedDate}
      showOutsideDays
      weekStartsOn={1} // Monday
    />
  )
}

export default ChooseDate
